import _ from 'underscore';

class ScatterplotService {
    constructor($sce){

        let vm = this;

        vm.sce = $sce;
        vm.data = require('./data/china-cities.json');


    }


    getCityData(){
        let vm = this;

        vm.cityData = vm.data
            .map(function(item){
                return item
            });


        return vm.cityData;
    }


    getCityByName(cityName){
        let vm = this;

        vm.city = vm.data
            .filter(function(item){
                return item.geography.toLowerCase() === cityName;
            })
            .map(function(obj){
                return obj
            }).shift();


        return vm.city;


    }


}

export default angular
    .module('scatterplotService', [])
    .service('scatterplotService', ScatterplotService)
    .name;

ScatterplotService.$inject = ['$sce'];


// WEBPACK FOOTER //
// ./src/app/services/scatterplot.service.js